// extracted by mini-css-extract-plugin
module.exports = {"d18a5375":"d18a5375"};